<template>
  <vx-card v-show="isCardActiveLocal" :style="{ 'background-color': question.status == 'correct' && quizType == 'graded' ? 'rgba(107, 255, 81, 0.3)' : question.status == 'answered' || quizType == 'survey' ? 'none' : 'rgba(255, 56, 56, 0.3)' }">
    <div class="vx-row">
      <div class="vx-col w-full">
        <table class="likertScale">
          <th>Question</th>
          <th v-for="(scalelabels, scaleIndex) in question.scaleLables" :key="scaleIndex">{{scalelabels.text}}</th>
          <tr :data="textquestion" :key="indextr" v-for="(textquestion, indextr) in question.text" >
            <td>
              {{textquestion.text}}
            </td>
            <td v-for="(optionsAvailable, indexOption) in question.scaleLables" :key="indexOption">
              <feather-icon v-if="indexOption == question.answers[indextr].labelIndex" class="correctCircle" icon="CheckCircleIcon"></feather-icon>
              <feather-icon v-if="indexOption != question.answers[indextr].labelIndex" class="CircleEmpty" icon="CircleIcon"></feather-icon>
            </td>
          </tr>  
        </table>
      </div>
    </div>
    <comment-view :isCardActive="commentView" :question="question" :quizType="quizType" :predefinedComments="predefinedComments"/>
  </vx-card>
</template>

<script>
  import commentView from './iSpringCommentView.vue';
  export default {
    components: {
      commentView
    },
    props: {
      isCardActive: {
        type: Boolean,
        required: true
      },
      question: {
        type: Object,
        required: false
      },
      predefinedComments: {
        type:Array,
        required: false
      },
      quizType: {
        type: String,
        required: false
      }
    },
    data() {
      return {
        commentView: true
      }
    },
    computed: {
      isCardActiveLocal: {
        get() {
          return this.isCardActive;
        },
        set(val) {
          if (!val) {
            this.$emit("closeCard");
            this.initValues();
          }
        }
      },
    },
    watch: {
      isCardActive: function(val) {
        if(val){
          var self = this;
          if(self.question){

          }else{
            self.initValues();
          }
        }
      },
      question: function(val) {
        if(val){
          this.commentView = true;
        }
      }
    },
    methods: {
      initValues() {
        this.errors.clear();
      },
    }
  }

</script>

<style lang="scss">

</style>
